import { useState } from "react";
import { EXPORT_FORMATS } from "../../../constants/exportFormats";
import { Dropdown } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import "./ExportDropdown.css";

const ExportDropdown = ({ onExport, disabled }) => {
  const [exporting, setExporting] = useState(false);
  const [activeFormat, setActiveFormat] = useState(null);

  const handleSelect = async (formatKey) => {
    if (exporting) return;
    setExporting(true);
    setActiveFormat(formatKey);
    try {
      await onExport(formatKey);
    } finally {
      setExporting(false);
      setActiveFormat(null);
    }
  };

  return (
    <Dropdown className="export-dropdown-wrapper">
      <Dropdown.Toggle
        className="sidebar-primary-btn export-toggle-btn"
        data-testid="results-export-button"
        disabled={disabled || exporting}
      >
        {exporting ? (
          <>
            <CircularProgress size={14} className="export-toggle-spinner" />
            Export en cours…
          </>
        ) : (
          <>Exporter</>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="export-dropdown">
        {EXPORT_FORMATS.map((fmt) => {
          const isActive = activeFormat === fmt.key;
          const itemClassName = [
            "export-dropdown-item",
            isActive && "is-active",
            exporting && "is-exporting",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <Dropdown.Item
              key={fmt.key}
              data-testid={`results-export-option-${fmt.key}`}
              onClick={() => handleSelect(fmt.key)}
              disabled={exporting}
              className={itemClassName}
            >
              {/* Icon */}
              <span className="export-item-icon">
                {isActive && exporting ? (
                  <CircularProgress
                    size={16}
                    className="export-item-icon-spinner"
                  />
                ) : (
                  fmt.icon
                )}
              </span>
              <div className="export-item-labels">
                <span className="export-item-title">{fmt.label}</span>
                <span className="export-item-desc">{fmt.desc}</span>
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default ExportDropdown;